/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_RoarInputs */

const fr_rapid_eager_otter_roar = /** @type {(inputs: Rapid_Eager_Otter_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer l'annulation`)
};

/**

* @param {Rapid_Eager_Otter_RoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_roar = /** @type {((inputs?: Rapid_Eager_Otter_RoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_RoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_roar(inputs)
});